import React, { useEffect, useState } from "react";
import moment from 'moment';
import { get } from "lodash";
import { Field } from "redux-form";

import { Button, Checkbox } from "../Field";
import { getIcon } from "../../helpers/icons";
import { planList } from "../../helpers/list";
import Link from "../Link";
import PlanList from "./PlanList";
import AsyncGet from "../AsyncGet";
import AsyncForm from "../AsyncForm";
import Input from "../Field/Input/Input";
import Title from "../../components/Title";
import FormatPrice from "../../pages/Widgets/Register/Step/FormatPrice";
import PaymentForm from "../../pages/Widgets/Register/Step/PaymentForm";
import Placeholder from "../../assets/image/notfoundbg.jpeg";

import style from "./style.module.css";
import Background from "../Background";
import Spacer from "../Spacer";
import Editor from "../Editor";

export default function RenewMembership(props) {
    const {
        closeDialog = "",
        userProfile = {}
    } = props;

    const today = moment();
    const monthExpiry = moment(today).add(1, 'months').format('MMMM D, YYYY');
    const yearExpiry = moment(today).add(1, 'years').format('MMMM D, YYYY');
    const plan = get(userProfile, "oldMembership.membership_id", "");
    const planName = get(userProfile, "oldMembership.plan.full_title", "");
    const planType = get(userProfile, "oldMembership.plan.plan_type", "");
    let originalTotal = get(userProfile, "oldMembership.plan.price", 0);

    const [step, setStep] = useState(null);
    const [expiry, setExpiry] = useState(monthExpiry);
    const [paymentIntentDetails, setPaymentIntentDetails] = useState({});
    const [couponId, setCouponId] = useState(null);
    const [total, setTotal] = useState(get(userProfile, "oldMembership.plan.price", 0));
    const [promoDetail, setPromoDetail] = useState({
        "status": false,
        "id": "",
        "discount_percentage": "",
    });

    useEffect(() => {
        if (planType === 2) {
            setExpiry(monthExpiry)
        }
        else if (planType === 1) {
            setExpiry(yearExpiry)
        }
        // eslint-disable-next-line
    }, [plan])

    useEffect(() => {
        const calculateTotal = () => {
            const baseTotal = parseFloat(total) || 0;
            const discountPercentage = Math.min(parseFloat(promoDetail.discount_percentage) || 0, 99);
            const discount = promoDetail.status
                ? (baseTotal * discountPercentage) / 100
                : 0;

            return (baseTotal - discount).toFixed(2);
        };

        setTotal(calculateTotal());
        // eslint-disable-next-line
    }, [promoDetail]);

    return (
        <div className={`${style.feedback} ${style.changePlan} ${style.popupArea}`}>
            <div className={style.popupWrap}>
                <div className={style.sectionHeader}>
                    {
                        step === null && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                                <Title className="fontTeko" transform="uppercase" tag="h2">Current Membership plan</Title>
                            </>
                        )
                    }
                    {
                        step === "step2" && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                                <Title className="fontTeko" transform="uppercase" tag="h2">SELECT PAYMENT METHOD</Title>
                            </>
                        )
                    }
                    {
                        step === "step3" && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                                <Title className="fontTeko" transform="uppercase" tag="h2">ENTER PAYMENT DETAILS</Title>
                                <Title tag="p">Choose how you would like to pay for your membership</Title>
                            </>
                        )
                    }
                    {
                        step === "step4" && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                            </>
                        )
                    }
                </div>
                {
                    step === null && (
                        <div className={style.sectionBody}>
                            <AsyncForm
                                id="ChangePlan"
                                url={`/membership/change-plan/`}
                                permission="Change Plan"
                                showToastOnSuccess={false}
                                initialValues={
                                    {
                                        plan_id: plan,
                                    }
                                }
                                render={() => {
                                    return (
                                        <>
                                            <PlanList
                                                userProfile={userProfile}
                                                currentPlanId={plan}
                                            />
                                            <div className={style.buttonRow}>
                                                <Button
                                                    onClick={() => { setStep("step2") }}
                                                    color="buttonPrimary"
                                                    label="NEXT"
                                                />
                                                <Button
                                                    onClick={closeDialog}
                                                    color="buttonPrimaryWithOutBg"
                                                    label="CANCEL"
                                                />
                                            </div>
                                        </>
                                    )
                                }}
                            />
                        </div>
                    )
                }
                {
                    step === "step2" && (
                        <div className={`${style.sectionBody} ${style.renewIntent}`}>
                            <AsyncForm
                                url="/membership/renew-intent"
                                permission="Renew Intent"
                                showToastOnSuccess={false}
                                onSave={({ data }) => {
                                    setPaymentIntentDetails(data);
                                    setStep("step3");
                                }}
                                initialValues={{
                                    auto_renewal: 1
                                }}
                                render={({ fetching, formValues, handleSubmit, onSubmit }) => {
                                    return (
                                        <>
                                            <AsyncGet
                                                url="/payment/verify-coupon"
                                                method="post"
                                                permissionText={false}
                                                paramsData={
                                                    {
                                                        coupon_code: get(formValues, 'coupon_code', '')
                                                    }
                                                }
                                                onFetch={({ data }) => {
                                                    if (data.discount_percentage !== undefined) {
                                                        setPromoDetail(prevState => ({
                                                            ...prevState,
                                                            status: true,
                                                            id: data.id,
                                                            discount_percentage: data.discount_percentage
                                                        }));
                                                        setCouponId(data.id);
                                                    }
                                                }}
                                                onError={() => {
                                                    setPromoDetail(prevState => ({
                                                        ...prevState,
                                                        status: false,
                                                        id: "",
                                                        discount_percentage: ""
                                                    }));
                                                    setTotal(originalTotal);
                                                    setCouponId(null);
                                                }}
                                                render={({ loadFromAPI }) => {
                                                    return (
                                                        <>
                                                            <div className={`${style.formRow} ${style.promotionalWrap}`}>
                                                                <Field
                                                                    name="coupon_code"
                                                                    component={Input}
                                                                    placeholder="Enter promotional code"
                                                                    label="Have a promotional code?"
                                                                />
                                                                <Link
                                                                    className={`${style.applyButton}`}
                                                                    onClick={loadFromAPI}
                                                                >
                                                                    APPLY
                                                                </Link>
                                                            </div>
                                                            {
                                                                promoDetail.status === true && (
                                                                    <div className={style.couponToast}>
                                                                        <div className={`${style.toast} ${style.green}`}>
                                                                            <i className={getIcon("Check")}></i>
                                                                            Promotional code applied
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }}
                                            />
                                            <div className={style.listWrap}>
                                                <div className={`${style.listItem} ${style.promotionalCodeApplyedAmountDetails}`}>
                                                    <div className={style.mainArea}>
                                                        <div className={style.planName}>
                                                            <Title className="fontMontserrat" tag="p">{planName}</Title>
                                                            <Title className="fontMontserrat" tag="p"><FormatPrice planType={planType} price={total} /></Title>
                                                        </div>
                                                        <div className={style.promotionalDescription}>
                                                            <Title className="fontMontserrat" tag="p">
                                                                <span>{planName}</span>
                                                                <span>{planList()[planType || '']}</span>
                                                                <span><FormatPrice planType={planType} price={total} /></span>
                                                                {
                                                                    promoDetail.status === true && (
                                                                        <span>{promoDetail.discount_percentage}% Off Promotion</span>
                                                                    )
                                                                }
                                                            </Title>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${style.listItem} ${style.overallTotal}`}>
                                                    <div className={style.mainArea}>
                                                        <div className={style.planName}>
                                                            <Title className="fontMontserrat" transform="textUpperCase" tag="h5">Overall total</Title>
                                                            <Title tag="p"><FormatPrice planType={planType} price={total} /></Title>
                                                        </div>
                                                        <div className={style.promotionalDescription}>
                                                            <Title tag="p">Your {planList()[planType || '']} Subscription will auto renew on {expiry}</Title>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={style.formRow}>
                                                    <Field
                                                        name="auto_renewal"
                                                        component={Checkbox}
                                                        checkValue={1}
                                                        unCheckedValue={0}
                                                        label="Enable Auto-Renewal"
                                                    />
                                                </div>
                                                <div className={style.buttonRow}>
                                                    <Button
                                                        onClick={handleSubmit(onSubmit)}
                                                        fetching={fetching}
                                                        color="buttonPrimary"
                                                        label="NEXT"
                                                    />
                                                    <Button
                                                        fetching={fetching}
                                                        onClick={closeDialog}
                                                        color="buttonPrimaryWithOutBg"
                                                        label="CANCEL"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )
                                }}
                            />
                        </div>
                    )
                }
                {
                    step === "step3" && (
                        <div className={`${style.sectionBody} ${style.paymentPopup}`}>
                            <PaymentForm
                                personalDetails={userProfile}
                                paymentIntentDetails={paymentIntentDetails.intent}
                                planId={get(userProfile, "membership.membership_id")}
                                total={total}
                                color="buttonPrimary"
                                from="renewmembership"
                                setStep={setStep}
                                couponId={couponId}
                            />
                        </div>
                    )
                }
                {
                    step === "step4" && (
                        <div className={`${style.sectionBody} ${style.paymentSuccessPopup}`}>
                            <div className={style.placeholderWrap}>
                                <Background src={Placeholder} size={"716x345"} />
                            </div>
                            <Spacer />
                           <Title className="fontTeko" transform="uppercase" tag="h2">CONGRATULATIONS</Title>
                           <Editor text={"Lorem ipsum dolor sit amet consectetur. Ipsum non pulvinar ipsum at nulla a lacinia ut. Curabitur ut id iaculis ligula nisi mattis. Nunc lorem elit sit mauris vitae consequat feugiat quis. Arcu ut ultrices interdum tristique id lectus id risus arcu."} />
                           <div className={style.buttonRow}>
                                <Button
                                    link="/"
                                    color="buttonPrimary"
                                    label="BROWSE CONTENT"
                                />
                                <Button
                                    onClick={() => { window.location.reload() }} 
                                    color="buttonPrimaryWithOutBg"
                                    label="BACK TO PROFILE"
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}